module.exports = __webpack_public_path__ + "static/media/readytobuild.86ecf2b0.png";